import { computed, signal, Service } from '@angular/core';

@Service()
export class ToolbarService {
  readonly announcementElHeight = signal(0);
  readonly stickyHeaderElHeight = signal(0);

  readonly totalElHeight = computed(() => {
    return this.announcementElHeight() + this.stickyHeaderElHeight();
  });
}
